/**
 * The kinds of element a requirement can link to (issue #48), as the server
 * names them - `db/requirement_links.TARGETS`. A screen showing one of these
 * shows the requirements linked to it.
 */
export const LINKABLE_KINDS = ['interface', 'state', 'design_port', 'design_part', 'function']
